import React, { memo } from 'react';
import styles from "./styles/ProductList.module.css";
import Product from './Product';

const ProductList = ({ products = [],loadingDeta,openDataCard }) => {

  return (
    <section>
      <div className={styles.products}>
        {products.map((product, index) => (
          <Product
            key={`${product.id}-${index}`}
            product={product}
            loadingDeta={loadingDeta}
            openDataCard={openDataCard}
          />
        ))}
      </div>
    </section>
  );
};

export default memo(ProductList);
